import { DataSourceReturn } from "src/app/services/Repositorys/type";
import { IMessageGetAllByRoomIdOutPut } from "../../usecase/message/message-get-all-by-room-Id";
import { MessageAttachmentInput } from "../../usecase/message/message-attachment-upload-use-case.service";
import { Result } from "neverthrow";
import { HttpErrorResponse } from "@angular/common/http";

export interface IGetMessagesFromRoomParams  {
 roomId: string
 lastMessageDate?: string
}

export abstract class IMessageRemoteRepository {
  abstract getMessagesFromRoom(input: IGetMessagesFromRoomParams): DataSourceReturn<IMessageGetAllByRoomIdOutPut>
  abstract messageAttachmentUpload(input: MessageAttachmentInput): Promise<Result<String, HttpErrorResponse>>
}
